import { assetService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  GET_ASSETS,
  GET_ASSETS_REFERENCES
} from './mutationTypes';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';


const actions = {
  async getAssets({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'getAssets' });
    commit(GET_ASSETS, []);
    try {
      const response = await assetService.getAssets(rootState.currentAccountId, null, true);
      commit(GET_ASSETS, response);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'getAssets' });
    } catch (e) {
      commit(GET_ASSETS, []);
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'getAssets', error: e });
    }
  },
  async getAssetReferences({ rootState, commit }, assetId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'getAssetReferences' });
    commit(GET_ASSETS_REFERENCES, []);
    try {
      const response = await assetService.getAssetReferences(rootState.currentAccountId, assetId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'getAssetReferences' });
      commit(GET_ASSETS_REFERENCES, response.data);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'getAssetReferences', error: e });
      commit(GET_ASSETS_REFERENCES, []);
    }
  },
  async deleteAsset({ rootState, commit, dispatch }, assetId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'deleteAsset' });
    try {
      await assetService.deleteAsset(rootState.currentAccountId, assetId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'deleteAsset' });
      dispatch('getAssets');
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'deleteAsset', error: e });
    }
  },
  async uploadAsset({ rootState, commit, dispatch }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'uploadAsset' });
    try {
      var uploadedAsset = await assetService.uploadAsset(rootState.currentAccountId, payload.file, payload.fileName, payload.fileType, payload.isPublic, payload.links);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'uploadAsset' });
      dispatch('getAssets');
      return uploadedAsset;
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'uploadAsset', error: e });
    }
  },
};

export default actions;